import { render, staticRenderFns } from "./ErrorBlock.vue?vue&type=template&id=c0fb520e&scoped=true&"
import script from "./ErrorBlock.vue?vue&type=script&lang=js&"
export * from "./ErrorBlock.vue?vue&type=script&lang=js&"
import style0 from "./ErrorBlock.vue?vue&type=style&index=0&id=c0fb520e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0fb520e",
  null
  
)

export default component.exports